import { WidgetsCargoIdDetailMain } from '@/widgets/cargo-id-detail';

export const PagesCargoIdDetailMain = () => <WidgetsCargoIdDetailMain />;
